import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { mockData } from '../mock';

const About = () => {
  return (
    <section id="about" className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-950">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Image */}
          <div className="relative order-2 lg:order-1">
            <div className="relative rounded-2xl overflow-hidden shadow-xl border border-gray-800">
              <img
                src="https://customer-assets.emergentagent.com/job_cck-transport-hub/artifacts/fwvjlol6_cck.jpeg"
                alt="CCK Possibilities fleet"
                className="w-full h-[400px] object-cover"
              />
            </div>
            <div className="absolute -top-6 -right-6 bg-gradient-to-r from-cyan-500 to-purple-600 text-white rounded-xl shadow-xl p-6 max-w-xs">
              <div className="text-4xl font-bold">98%</div>
              <div className="text-sm mt-1 opacity-90">On-time arrival rate</div>
            </div>
          </div>

          {/* Right Content */}
          <div className="space-y-6 order-1 lg:order-2">
            <div className="space-y-4">
              <h2 className="text-4xl font-bold text-white">
                {mockData.about.title}
              </h2>
              <p className="text-lg text-gray-300 leading-relaxed">
                {mockData.about.description}
              </p>
            </div>

            {/* Highlights */}
            <div className="space-y-4 pt-4">
              {mockData.about.highlights.map((highlight, index) => (
                <div key={index} className="flex items-start space-x-3">
                  <CheckCircle2 className="w-6 h-6 text-cyan-400 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-300 text-lg">{highlight}</span>
                </div>
              ))}
            </div>

            {/* Additional info */}
            <div className="pt-6">
              <p className="text-gray-400 italic">
                We can get you where you need to go anywhere in or out of state for your appointments.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
